// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerConnectedApps_DTpv5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 20px 0;
  p {
    margin: 0;
    color: var(--_2-color);
  }
}

.noFoundAutomate_JkdoX {
  color: var(--_71-color);
}

.automatesConnectedApps_FaHmE {
  /* border: 1px solid var(--d9d9e3-border);
   */
  /* border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px; */
  border-bottom: 1px solid var(--d9d9e3-border);
  font-size: 12px;
  .option_vIYLU {
    display: flex;
    align-items: center;
    gap: 10px;
    label {
      margin-bottom: 0;
    }
    span {
      color: var(--_2-color);
    }
    p {
      margin: 0;
      color:var(--_71717a-color);
    }
  }

.toggleSwitch_UoJO1 {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

.toggleSwitch_UoJO1 input {
  opacity: 0;
  width: 0 !important;
  height: 0 !important;
  display: none;
}
.slider_HARcr {
  position: absolute;
  cursor: pointer;
  background-color: var(--c-background);
  border-radius: 24px;
  width: 100%;
  height: 100%;
  transition: background-color 0.3s;
}

.slider_HARcr::before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 2px;
  background-color: var(--white-background);
  border-radius: 50%;
  transition: transform 0.3s;
}

.toggleSwitch_UoJO1 input:checked + .slider_HARcr {
  background-color: var(--black-color);
}

.toggleSwitch_UoJO1 input:checked + .slider_HARcr::before {
  transform: translateX(14px);
  -webkit-transform: translateX(14px);
  -moz-transform: translateX(14px);
  -ms-transform: translateX(14px);
  -o-transform: translateX(14px);
}
  .automateConnectedApps_BBqfV {
    border-bottom: 1px solid var(--d9d9e3-border);
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px;
    justify-content: space-between;
    .container_w2ESR {
      display: flex;
      align-items: center;
      gap: 10px;
      img{
        width: 50px;
        height: 50px;
      }
    }
    &:last-child {
      border-bottom: none;
    }

    .automateConnectedAppsInfo_Sc2Kv {
      display: flex;
      flex-direction: column;

      gap: 5px;
      > div {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      p {
        margin: 0;
        color: var(--_6-color);
      }
      svg{
        width: 14px;
        height: 14px;
      }
    }
  }
}

.searchIconsWrappers_k2pAb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.inputTokenContainer_oA63C{
  input{
    background:#f4f4f4; 
    border:none;
  }

  input::placeholder{
    color: #757575;
    font-size: 12px;
  }
}


.buttonContainer_Q0qZy {
  display: flex;
  gap: 5px;
  justify-content: flex-start;
  margin-top: 10px;


button {
  color:var(--_6-color);
    font-weight: 600;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background-color: var(--white-background);
  cursor: pointer;
  font-size: 15px;
}
.buttonActive_ZeDUT{
  background-color: var(--ececf1-background);
}

button:hover {
  /* background-color: #ddd; */
}
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/ConnectedApps/ConnectedApps.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd;IACE,SAAS;IACT,sBAAsB;EACxB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE;EACF;;;;0BAIwB;EACxB,6CAA6C;EAC7C,eAAe;EACf;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;MACE,gBAAgB;IAClB;IACA;MACE,sBAAsB;IACxB;IACA;MACE,SAAS;MACT,0BAA0B;IAC5B;EACF;;AAEF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;AAChC;EACE;IACE,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,8BAA8B;IAC9B;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT;QACE,WAAW;QACX,YAAY;MACd;IACF;IACA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,sBAAsB;;MAEtB,QAAQ;MACR;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;MACX;MACA;QACE,SAAS;QACT,sBAAsB;MACxB;MACA;QACE,WAAW;QACX,YAAY;MACd;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;;;AAGlB;EACE,qBAAqB;IACnB,gBAAgB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;AAC9B;AACA","sourcesContent":[".headerConnectedApps {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: 20px 0;\n  p {\n    margin: 0;\n    color: var(--_2-color);\n  }\n}\n\n.noFoundAutomate {\n  color: var(--_71-color);\n}\n\n.automatesConnectedApps {\n  /* border: 1px solid var(--d9d9e3-border);\n   */\n  /* border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px; */\n  border-bottom: 1px solid var(--d9d9e3-border);\n  font-size: 12px;\n  .option {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    label {\n      margin-bottom: 0;\n    }\n    span {\n      color: var(--_2-color);\n    }\n    p {\n      margin: 0;\n      color:var(--_71717a-color);\n    }\n  }\n\n.toggleSwitch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0 !important;\n  height: 0 !important;\n  display: none;\n}\n.slider {\n  position: absolute;\n  cursor: pointer;\n  background-color: var(--c-background);\n  border-radius: 24px;\n  width: 100%;\n  height: 100%;\n  transition: background-color 0.3s;\n}\n\n.slider::before {\n  content: \"\";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  left: 4px;\n  bottom: 2px;\n  background-color: var(--white-background);\n  border-radius: 50%;\n  transition: transform 0.3s;\n}\n\n.toggleSwitch input:checked + .slider {\n  background-color: var(--black-color);\n}\n\n.toggleSwitch input:checked + .slider::before {\n  transform: translateX(14px);\n  -webkit-transform: translateX(14px);\n  -moz-transform: translateX(14px);\n  -ms-transform: translateX(14px);\n  -o-transform: translateX(14px);\n}\n  .automateConnectedApps {\n    border-bottom: 1px solid var(--d9d9e3-border);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 5px;\n    justify-content: space-between;\n    .container {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      img{\n        width: 50px;\n        height: 50px;\n      }\n    }\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .automateConnectedAppsInfo {\n      display: flex;\n      flex-direction: column;\n\n      gap: 5px;\n      > div {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n      p {\n        margin: 0;\n        color: var(--_6-color);\n      }\n      svg{\n        width: 14px;\n        height: 14px;\n      }\n    }\n  }\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.inputTokenContainer{\n  input{\n    background:#f4f4f4; \n    border:none;\n  }\n\n  input::placeholder{\n    color: #757575;\n    font-size: 12px;\n  }\n}\n\n\n.buttonContainer {\n  display: flex;\n  gap: 5px;\n  justify-content: flex-start;\n  margin-top: 10px;\n\n\nbutton {\n  color:var(--_6-color);\n    font-weight: 600;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  background-color: var(--white-background);\n  cursor: pointer;\n  font-size: 15px;\n}\n.buttonActive{\n  background-color: var(--ececf1-background);\n}\n\nbutton:hover {\n  /* background-color: #ddd; */\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerConnectedApps": `headerConnectedApps_DTpv5`,
	"noFoundAutomate": `noFoundAutomate_JkdoX`,
	"automatesConnectedApps": `automatesConnectedApps_FaHmE`,
	"option": `option_vIYLU`,
	"toggleSwitch": `toggleSwitch_UoJO1`,
	"slider": `slider_HARcr`,
	"automateConnectedApps": `automateConnectedApps_BBqfV`,
	"container": `container_w2ESR`,
	"automateConnectedAppsInfo": `automateConnectedAppsInfo_Sc2Kv`,
	"searchIconsWrappers": `searchIconsWrappers_k2pAb`,
	"inputTokenContainer": `inputTokenContainer_oA63C`,
	"buttonContainer": `buttonContainer_Q0qZy`,
	"buttonActive": `buttonActive_ZeDUT`
};
export default ___CSS_LOADER_EXPORT___;
